import React from "react";

// Formatea una fecha ISO como dd/mm/aaaa — compartido entre los mapas de ruta.
export function formatShortDate(iso) {
  if (!iso) return "—";
  const [y, m, d] = String(iso).slice(0, 10).split("-");
  if (!y || !m || !d) return "—";
  return `${d}/${m}/${y}`;
}

// Fecha ISO -> fracción [0,1] dentro de [baseYear-01-01, horizonEnd-12-31].
export function fracFecha(iso, baseYear, horizonEnd) {
  const t = new Date(`${iso}T00:00:00`).getTime();
  const a = new Date(baseYear, 0, 1).getTime();
  const b = new Date(horizonEnd, 11, 31).getTime();
  return Math.min(1, Math.max(0, (t - a) / (b - a)));
}

// Líneas verticales de grilla, una por año — usado por Gantt y Carriles.
export function GridYears({ horizon }) {
  return (
    <>
      {Array.from({ length: horizon + 2 }, (_, i) => (
        <div key={i} style={{ position: "absolute", left: `${((i / (horizon + 1)) * 100).toFixed(2)}%`, top: 0, bottom: 0, width: 1, background: "#E4EDF5" }} />
      ))}
    </>
  );
}

// Eje de años al tope del mapa de ruta — usado por Gantt y Carriles (cada
// uno con su propio ancho de columna de etiqueta).
export function YearAxis({ baseYear, horizon, margin }) {
  return (
    <div style={{ display: "flex", marginLeft: margin, position: "relative", height: 20 }}>
      {Array.from({ length: horizon + 1 }, (_, i) => (
        <div key={i} style={{ flex: 1, fontSize: 10, color: "#6B7A8E", borderLeft: "1px solid #E4EDF5", paddingLeft: 4 }}>
          {baseYear + i}
        </div>
      ))}
    </div>
  );
}
